import { type FC, type ComponentProps } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';

import { type PdpSharedDealerDetailsBioModalLazy_seller$data as Seller } from './__generated__/PdpSharedDealerDetailsBioModalLazy_seller.graphql.ts';

import { PdpSharedSellerDetailsModalLazy } from '../shared/PdpSharedSellerDetailsModal/PdpSharedSellerDetailsModalLazy.tsx';

const PdpSharedDealerDetailsBioModalLazyComponent: FC<
    Omit<ComponentProps<typeof PdpSharedSellerDetailsModalLazy>, 'seller' | 'sellerId'> & {
        seller: Seller;
    }
> = props => <PdpSharedSellerDetailsModalLazy {...props} sellerId={props.seller.serviceId} />;

export const PdpSharedDealerDetailsBioModalLazy = createFragmentContainer(
    PdpSharedDealerDetailsBioModalLazyComponent,
    {
        seller: graphql`
            fragment PdpSharedDealerDetailsBioModalLazy_seller on Seller {
                serviceId
            }
        `,
    }
);
